var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEikowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 3.33333,
    fill: "url(#paint0_linear_2913_11270)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2913_11270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.9375C11.032 4.9375 11.9747 5.19034 12.8287 5.6949C13.6827 6.20003 14.3586 6.87427 14.8564 7.71707C15.3543 8.56043 15.6105 9.50481 15.625 10.5513V11.5979H15.4509V11.609H9.91293V9.4289H13.2596C13.0123 8.74573 12.5965 8.18982 12.0116 7.76116C11.4266 7.33251 10.7557 7.11818 10 7.11818C9.05506 7.11818 8.24463 7.45418 7.56927 8.12675C6.89336 8.79932 6.55568 9.61142 6.55568 10.5631C6.55568 11.2245 6.73205 11.8133 7.08424 12.329C7.43643 12.8453 7.87625 13.25 8.40314 13.5447C8.93003 13.8388 9.47311 13.9934 10.0329 14.0079L9.97823 16.1881C8.56835 16.1373 7.30359 15.6143 6.18451 14.6186C4.97836 13.4621 4.375 12.1108 4.375 10.5625C4.375 9.53049 4.62951 8.58778 5.13799 7.73381C5.64646 6.87985 6.32628 6.20059 7.17634 5.69546C8.02695 5.19034 8.96799 4.9375 10 4.9375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2913_11270",
    x1: 1,
    y1: 19,
    x2: 35.3125,
    y2: -14.4688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC736D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142476,
    stopColor: "#DB5D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E85576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446912,
    stopColor: "#E4489C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580759,
    stopColor: "#BE45AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#7B44BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#5671EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739BF5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2913_11270"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.375,
    y: 4.9375,
    width: 11.25,
    height: 11.25,
    rx: 3.33333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEikowLogo);
export default __webpack_public_path__ + "static/media/eikow-logo.f35cc841c78597dda1d3b030979a7cfa.svg";
export { ForwardRef as ReactComponent };